<template>
  <div class="my-published-bookshelf-area">
    <el-scrollbar ref="scrollbar">
      <div class="my-published-bookshelf" id="js-published-bookshelf">
        <div class="bookshelf-item add-bookshelf-div" v-show="booksCurrentSubAccount == ''" @click="clickAddBooklib">
          <img src="@imgs/add-book.png" alt="" />
          <div>创建新{{ shelfLibData.userType }}</div>
        </div>
        <div class="bookshelf-item normal" v-for="item in shelfLibData.dataList" v-bind:key="item.id">
          <div class="bookshelf-bg-container" @click="clickViewBookshelf(item.openMode, item.id)">
            <img src="@imgs/bookshelf/bookshelf_bg.png" alt="" />
          </div>
          <div class="info-and-deal">
            <div class="title">
              <div class="title-name">{{ item.name }}</div>
              <div class="title-num">
                <img src="@imgs/bookshelf/bookshelf_icon.png" alt="" />
                <span>{{ shelfLibData.isShelf ? item.ebookList.length : item.itemList.length }}</span>
              </div>
            </div>
            <div class="deal-btn-wrapper">
              <el-tooltip effect="dark" v-show="booksCurrentSubAccount == ''" content="编辑" placement="bottom" v-if="item.readModel != 1">
                <img class="deal-btn icon-style" src="@imgs/compile.png" @click="clickEditBookshelf(item.id, item.name)" />
              </el-tooltip>
              <el-tooltip effect="dark" content="分享" placement="bottom" v-if="item.readModel != 1">
                <img class="deal-btn icon-style" src="@imgs/share-icon.png" @click="clickShareBookshelf(item.id, item.poster, item.openMode, item.name)" />
              </el-tooltip>
              <el-tooltip v-show="booksCurrentSubAccount == '' || !isSubAccount" effect="dark" content="删除" placement="bottom" v-if="item.readModel != 1">
                <img class="deal-btn icon-style" src="@imgs/delete-icon.png" @click="clickDelBookshelf(item.id)" />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <elPagination1 class="page-component" :layout="'prev, pager, next'" :total="shelfLibData.totalCount" :pageSize="10" :currentPage="currentPageNo" @handleCurrentChange="currentPageChange">
      <slot>
        共<span class="text-yellow">{{ shelfLibData.totalCount }}</span
        >条记录
      </slot>
    </elPagination1>
    <!-- 非会员新建专辑弹框 -->
    <TipDialog ref="memberDialog" :dialogOptions="memberDialogOptions"></TipDialog>
    <!-- 会员新建图书馆弹框 -->
    <AddTipDialog ref="buildDialog" :dialogOptions="buildDialogOptions" @clickConfirm="clickBuildConfirm"></AddTipDialog>
    <!-- 删除图书馆弹框 -->
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickConfirm="clickDeleteConfirm"></TipDialog>
    <!-- 分享图书馆弹框 -->
    <share-dialog ref="shareDialog" :qrObj="qrObj" :typeName="typeName" :isInset="isInset"></share-dialog>
  </div>
</template>

<script>
import elPagination1 from '@components/common/elPagination.vue'
import { mapState } from 'vuex'
// 非会员新建专辑弹框 会员新建专辑弹框 删除专辑弹框
import TipDialog from '@components/common/TipDialog.vue'
import AddTipDialog from '@components/common/AddTipDialog.vue'
// 分享专辑弹框
import ShareDialog from '@components/MyBookshelf/components/ShareDialog.vue'
import BookLibInterface from '@api/bookLib'
import { getProductsCount } from '@api/getBook'
import { setEncryption } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'libPublished',
  mixins: [compareVipRight],
  data() {
    return {
      typeName: '图书馆',
      replaceId: -1,
      currentPageNo: 1,
      deleteId: -1,
      // 会员新建专辑弹框配置项
      buildDialogOptions: {
        // 弹框类型
        type: 'build',
        // 弹框头部标题
        title: '新建图书馆',
        // 弹框内容
        label: '图书馆名称',
        value: '默认图书馆',
        message: '必须填写图书馆名称'
      },
      // 删除专辑弹框配置项
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '图书馆被删除后，里面的书刊专辑并不会丢失，你可重新选择、组合你的书刊专辑，将其添加到一个全新的图书馆'
      },
      bookLibList: [],
      DelCurId: '',
      qrObj: {
        value: '',
        iframeUrl: ''
      },
      isInset: true
    }
  },
  props: {
    shelfLibData: Object
  },
  components: {
    elPagination1,
    TipDialog,
    'share-dialog': ShareDialog,
    AddTipDialog
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    memberDialogOptions() {
      return {
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，仅允许创建${this.$store.state.common.vipRight.libNum}个图书馆，创建更多需先升级会员服务。`
      }
    },
    bookListPages() {
      return this.$store.state.manage.bookListPages
    },
    userName() {
      return localStorage.getItem('username')
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    },
    libData() {
      return this.libData
    }
  },
  methods: {
    // 会员新建专辑或者图书馆弹框确认
    clickBuildConfirm(inputContent) {
      if (this.shelfLibData.isShelf) {
        // 专辑
      } else {
        // 图书馆
        let params = {
          libraryName: inputContent,
          userName: this.userName
        }
        this.$emit('libBuildCon', params)
      }
    },
    // 删除专辑或者图书馆确认
    clickDeleteConfirm() {
      BookLibInterface.delLibrary(this.DelCurId).then((res) => {
        if (res.status === 200) {
          this.$parent.getBookLibList(this.currentPageNo)
        }
      })
    },
    //翻页
    currentPageChange(val) {
      this.currentPageNo = val
      if (this.shelfLibData.isShelf) {
        this.getBookShelfList(val)
      } else {
        this.$emit('changePage', val)
      }
      let dom = document.getElementById('js-published-bookshelf')
      if (dom != null) {
        if (dom.scrollTop > 0) {
          dom.scrollTop = 0
        }
      }
    },
    // 新建专辑或者图书馆
    async clickAddBooklib() {
      const param = {
        userName: this.userName,
        isChild: this.isSubAccount,
        type: 'lib'
      }
      let libCount = this.totalCount
      await getProductsCount(param).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          libCount = res.data.data.sum
        }
      })
      if (await this.compareRight({ type: 'num', key: 'libNum', value: libCount })) {
        this.$refs.buildDialog.visible = true
      } else {
        this.$refs.memberDialog.visible = true
      }
    },
    // 查看专辑或者图书馆
    clickViewBookshelf(openMode, id) {
      const encryption_id = setEncryption(id)
      if (this.shelfLibData.isShelf) {
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
        let routeUrl1 = this.$router.resolve({
          path: '/bookshelfdetail',
          query: { id: id }
        })
        window.open(routeUrl1.href, '_blank')
        // this.$router.push({ path: '/bookshelfdetail', query: { id: id } })
      } else {
        let routeUrl2 = this.$router.resolve({
          path: '/bookLibdetail',
          query: { id: encryption_id, openMode }
        })
        window.open(routeUrl2.href, '_blank')
        // this.$router.push({ path: '/bookLibdetail', query: { id: id } })
      }
    },
    // 编辑专辑或者图书馆
    clickEditBookshelf(id, name) {
      if (this.shelfLibData.isShelf) {
      } else {
        let componentManager = 'LibEdit'
        // this.$store.commit('config/UPDATE_ALBUMID', id)
        window.sessionStorage.setItem('libId', id)
        this.$store.commit('config/UPDATE_BOOKLIBTITLE_TITLE', name)
        this.$store.commit('manage/UPDATE_COMPONENTMANAGER', componentManager)
      }
    },
    // 分享专辑或者图书馆
    clickShareBookshelf(id, poster, openMode, name) {
      const encryption_id = setEncryption(id)
      this.replaceId = id
      this.$refs.shareDialog.dialogVisible = true
      this.qrObj.value = window.location.href.replace('list', 'bookLibdetail?id=') + encryption_id + '&openMode=' + openMode
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = name
      this.qrObj.isShowPoster = poster
    },
    // 删除专辑或者图书馆
    clickDelBookshelf(id) {
      this.$refs.deleteDialog.visible = true
      this.DelCurId = id
    }
  }
}
</script>
<style lang="scss" scoped>
.my-published-bookshelf-area {
  .bookshelft-header-div {
    padding: 8px 0;
    .bookshelf-header {
      font-size: 17px;
      margin-right: 18px;
      color: #000;
      font-weight: 400;
    }
    .num-info {
      font-size: 16px;
      display: inline-block;
    }
  }
  .my-published-bookshelf {
    padding-top: 16px;
    height: calc(100vh - 220px);
    min-height: 360px;
    overflow-y: auto;
    .bookshelf-item {
      display: inline-block;
      vertical-align: top;
      width: 249px;
      height: 340px;
      border: 1px solid rgba(232, 232, 232, 1);
      color: rgba(255, 255, 255, 0.8);
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      color: #fff;
      line-height: 20px;
      cursor: pointer;
      .shade {
        position: absolute;
        width: 100%;
        height: 100%;
        font-size: 14px;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        cursor: default;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
      .get-book {
        height: 280px;
        width: 100%;
      }
      .bookshelf-bg-container {
        position: relative;
        width: 100%;
        height: calc(100% - 80px);
      }
      .info-and-deal {
        // display: none;
        position: absolute;
        width: 100%;
        height: 80px;
        background: rgba(0, 0, 0, 0.5);
        bottom: 0;
        left: 0;
        padding: 0 10px;
        line-height: 21px;
        font-size: 14px;
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px 0;
          .title-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .title-num {
            padding-left: 3px;
            img {
              margin-right: 3px;
              margin-bottom: -3px;
            }
          }
        }
      }
      .deal-btn-wrapper {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 42px;
        .deal-btn {
          display: inline-block;
          width: 20px;
        }
      }
    }
    .bookshelf-item:hover .info-and-deal {
      display: block;
    }
    .normal .bookshelf-bg-container img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
    .add-bookshelf-div {
      color: #000;
      padding: 150px 20px;
      text-align: center;
      img {
        margin-bottom: 16px;
      }
    }
  }
  .page-component {
    position: fixed;
    background-color: #fff;
    width: calc(100% - 265px);
    bottom: 20px;
    right: 20px;
    left: 245px;
  }
  .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    // .el-dialog {
    //   margin: 0 !important;
    //   width: 400px;
    //   .el-dialog__footer {
    //     button {
    //       width: 48%;
    //     }
    //   }
    // }
  }
}
</style>
